<!-- Modal Header -->
<form [formGroup]="createUserForm" class="create-employee-form" (keydown.enter)="submitOnEnter($event)">
  <div class="modal-header">
    <h2 class="modal-title">{{ isEdit ? 'Edit Employee' : (isActivationHandoff ? 'Add your first employee' : 'Add employee') }}</h2>
    <button class="close-btn" type="button" (click)="modalClose()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p class="activation-create-lead" *ngIf="!isEdit && isActivationHandoff">
    {{ activationHandoffLead }}
  </p>
  <div class="modal-content">

    <!-- Profile Image Upload Section (Edit Mode Only) -->
    <div class="section" *ngIf="isEdit">
      <label class="section-label">Profile Image</label>
      <div class="profile-image-upload-container">
        <div class="profile-image-preview">
          <div class="avatar-preview-wrapper"
            [class.has-image]="profileImagePreview || (existingProfileImage && !shouldRemoveImage)">
            <img *ngIf="profileImagePreview" [src]="profileImagePreview" alt="Profile Preview"
              class="avatar-preview-img" (error)="profileImagePreview = null">
            <img *ngIf="!profileImagePreview && existingProfileImage && !shouldRemoveImage" [src]="existingProfileImage"
              alt="Current Profile" class="avatar-preview-img" (error)="existingProfileImage = null">
            <div *ngIf="!profileImagePreview && (!existingProfileImage || shouldRemoveImage)" class="avatar-initials">
              {{ getInitials() }}
            </div>
            <div class="avatar-overlay" *ngIf="(profileImagePreview || existingProfileImage) && !shouldRemoveImage">
              <button type="button" mat-icon-button class="remove-image-btn" (click)="removeProfileImage()"
                matTooltip="Remove image" aria-label="Remove image">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="upload-indicator" *ngIf="isImageUploading">
              <mat-icon class="spinning">hourglass_empty</mat-icon>
            </div>
          </div>
        </div>
        <div class="profile-image-actions">
          <input #fileInput type="file" accept="image/jpeg,image/jpg,image/png,image/webp"
            (change)="onFileSelected($event)" style="display: none;">
          <div class="action-buttons">
            <button type="button" mat-stroked-button class="upload-btn" (click)="fileInput.click()">
              <span class="material-symbols-outlined file-icon"> {{ profileImagePreview || existingProfileImage ?
                'add_photo_alternate' : 'upload' }}</span>
              <span>{{ profileImagePreview || existingProfileImage ? 'Replace Image' : 'Upload Image' }}</span>
            </button>
            <button type="button" mat-flat-button color="primary" class="save-image-btn"
              *ngIf="profileImageFile || shouldRemoveImage" [disabled]="isImageUploading" (click)="saveProfileImage()">
              <mat-icon *ngIf="!isImageUploading">save</mat-icon>
              <mat-icon *ngIf="isImageUploading" class="spinning">hourglass_empty</mat-icon>
              <span>{{ isImageUploading ? 'Saving...' : 'Save Image' }}</span>
            </button>
          </div>
          <div class="file-info">
            <p class="file-hint" *ngIf="!profileImagePreview && !existingProfileImage">
              <mat-icon>info_outline</mat-icon>
              <span>Accepted formats: JPEG, JPG, PNG, WEBP (Max size: 300KB)</span>
            </p>
            <p class="file-error" *ngIf="imageUploadError">
              <mat-icon>error_outline</mat-icon>
              <span>{{ imageUploadError }}</span>
            </p>
            <p class="file-success" *ngIf="imageUploadSuccess">
              <mat-icon>check_circle_outline</mat-icon>
              <span>{{ imageUploadSuccess }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 1–2. Identity -->
    <div class="section identity-section">
      <div class="form-row" *ngIf="isEdit">
        <mat-form-field appearance="outline" class="form-field" style="width: 100%;">
          <mat-label>Email</mat-label>
          <input matInput [value]="userEmail" aria-label="Email" disabled>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field" floatLabel="always">
          <mat-label>First name</mat-label>
          <input matInput formControlName="first_name" cdkFocusInitial />
          <mat-error *ngIf="createUserForm.get('first_name')?.hasError('required')">Enter the employee's first name</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field" floatLabel="always">
          <mat-label>Last name</mat-label>
          <input matInput formControlName="last_name" />
          <mat-error *ngIf="createUserForm.get('last_name')?.hasError('required')">Enter the employee's last name</mat-error>
        </mat-form-field>
      </div>
      <div class="form-row identity-email-role"
        *ngIf="!isEdit && (createUserForm.get('version_type')?.value === 'general' || createUserForm.get('version_type')?.value === 'restricted')">
        <mat-form-field appearance="outline" class="form-field" floatLabel="always">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email"
            [readonly]="createUserForm.get('useRandomEmail')?.value" />
          <mat-error *ngIf="createUserForm.get('email')?.hasError('required')">Enter the employee's email</mat-error>
          <mat-error *ngIf="createUserForm.get('email')?.hasError('pattern')">Please enter a valid email</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field" *ngIf="showRoleField && !isActivationHandoff">
          <mat-label>Access role</mat-label>
          <mat-select formControlName="roles2" panelClass="role-select-panel">
            <mat-select-trigger>{{ selectedRoleLabel }}</mat-select-trigger>
            <mat-option *ngFor="let opt of creatableRoleOptions" [value]="opt.value">
              <span class="role-option-label">{{ opt.label }}</span>
              <span class="role-option-desc">{{ opt.description }}</span>
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="selectedRoleDescription">{{ selectedRoleDescription }}</mat-hint>
        </mat-form-field>
      </div>
      <div class="form-row" *ngIf="isEdit && showRoleField">
        <mat-form-field appearance="outline" class="form-field" style="width: 100%;">
          <mat-label>Access role</mat-label>
          <mat-select formControlName="roles2" panelClass="role-select-panel">
            <mat-select-trigger>{{ selectedRoleLabel }}</mat-select-trigger>
            <mat-option *ngFor="let opt of creatableRoleOptions" [value]="opt.value">
              <span class="role-option-label">{{ opt.label }}</span>
              <span class="role-option-desc">{{ opt.description }}</span>
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="selectedRoleDescription">{{ selectedRoleDescription }}</mat-hint>
        </mat-form-field>
      </div>
      <!-- Hidden mode: no email row — still show role when allowed -->
      <div class="form-row"
        *ngIf="!isEdit && createUserForm.get('version_type')?.value === 'silent' && showRoleField && !isActivationHandoff">
        <mat-form-field appearance="outline" class="form-field" style="width: 100%;">
          <mat-label>Access role</mat-label>
          <mat-select formControlName="roles2" panelClass="role-select-panel">
            <mat-select-trigger>{{ selectedRoleLabel }}</mat-select-trigger>
            <mat-option *ngFor="let opt of creatableRoleOptions" [value]="opt.value">
              <span class="role-option-label">{{ opt.label }}</span>
              <span class="role-option-desc">{{ opt.description }}</span>
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="selectedRoleDescription">{{ selectedRoleDescription }}</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <!-- 3. Tracking mode -->
    <div class="section mode-picker-section" *ngIf="!isEdit">
      <label class="section-label mode-picker-label" id="create-user-mode-label">Tracking mode</label>
      <div
        class="mode-cards create-user-mode-cards"
        role="radiogroup"
        aria-labelledby="create-user-mode-label">
        <div
          class="mode-card"
          role="radio"
          tabindex="0"
          *ngFor="let softwareType of softwareTypes"
          [class.is-picked]="!softwareType.locked && createUserForm.get('version_type')?.value === softwareType.value"
          [class.is-caution]="softwareType.value === 'silent'"
          [class.mode-card--locked]="softwareType.locked"
          [attr.aria-checked]="!softwareType.locked && createUserForm.get('version_type')?.value === softwareType.value"
          [attr.aria-disabled]="softwareType.locked"
          (click)="onSoftwareTypeCardClick(softwareType)"
          (keydown.enter)="onSoftwareTypeCardClick(softwareType)"
          (keydown.space)="onSoftwareTypeCardClick(softwareType); $event.preventDefault()">
          <div class="mode-card-top">
            <div
              class="mode-icon"
              [class.is-picked]="!softwareType.locked && createUserForm.get('version_type')?.value === softwareType.value">
              <mat-icon aria-hidden="true">{{ softwareType.icon }}</mat-icon>
            </div>
            <div class="mode-card-heading">
              <h3>
                {{ softwareType.label }}
                <mat-icon *ngIf="softwareType.locked" class="mode-lock" aria-hidden="true">lock</mat-icon>
              </h3>
              <span class="mode-tag" *ngIf="softwareType.recommended">Recommended</span>
            </div>
            <span
              class="mode-radio"
              [class.is-on]="!softwareType.locked && createUserForm.get('version_type')?.value === softwareType.value"
              aria-hidden="true"></span>
          </div>
          <ul class="mode-facts">
            <li *ngFor="let fact of softwareType.facts">
              <mat-icon aria-hidden="true">{{ fact.icon }}</mat-icon>
              <span>{{ fact.text }}</span>
            </li>
          </ul>
          <p class="mode-caution" *ngIf="softwareType.caution && createUserForm.get('version_type')?.value === softwareType.value">
            {{ softwareType.caution }}
          </p>
          <p class="mode-upgrade-hint" *ngIf="softwareType.locked">Upgrade to Professional to unlock</p>
        </div>
      </div>
    </div>

    <!-- 4a. Sign-in (Hidden): nothing to enter, say so instead of leaving a gap -->
    <div class="section sign-in-section" *ngIf="!isEdit && createUserForm.get('version_type')?.value === 'silent'">
      <label class="section-label">Sign-in</label>
      <p class="sign-in-note sign-in-note--flat">
        Hidden employees never sign in to SuperSee, so there is no email or password to set. A private login is created for them automatically.
      </p>
    </div>

    <!-- 4. Sign-in -->
    <div class="section sign-in-section"
      *ngIf="!isEdit && (createUserForm.get('version_type')?.value === 'general' || createUserForm.get('version_type')?.value === 'restricted')">
      <label class="section-label">Sign-in</label>
      <div class="send-credentials-row" *ngIf="!createUserForm.get('useRandomEmail')?.value">
        <mat-checkbox formControlName="send_email">
          <span class="send-credentials-label">Email login details to the employee</span>
        </mat-checkbox>
        <p class="sign-in-note" *ngIf="createUserForm.get('send_email')?.value">
          They'll receive an email with their login and a password we generate for them.
        </p>
      </div>
      <div class="form-row" *ngIf="passwordFieldVisible">
        <mat-form-field appearance="outline" class="form-field password-field form-field--full" floatLabel="always">
          <mat-label>Password</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" formControlName="password"
            autocomplete="new-password" />
          <button mat-icon-button matSuffix type="button" (click)="hide = !hide"
            [attr.aria-label]="hide ? 'Show password' : 'Hide password'" [attr.aria-pressed]="!hide">
            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <button mat-icon-button matSuffix type="button" (click)="copyPassword()" aria-label="Copy password"
            matTooltip="Copy">
            <mat-icon>content_copy</mat-icon>
          </button>
          <button mat-icon-button matSuffix type="button" (click)="generateAndSetRandomPassword()"
            aria-label="Regenerate password" matTooltip="Regenerate">
            <mat-icon>refresh</mat-icon>
          </button>
          <mat-hint>No email will be sent. Copy the password and share it with the employee securely.</mat-hint>
          <mat-error
            *ngIf="createUserForm.get('password')?.errors?.password && createUserForm.get('password')?.touched">
            {{ createUserForm.get('password')?.errors?.password }}
          </mat-error>
          <mat-error
            *ngIf="createUserForm.get('password')?.hasError('required') && !createUserForm.get('password')?.errors?.password">Password
            is required</mat-error>
          <mat-error
            *ngIf="createUserForm.get('password')?.hasError('minlength') && !createUserForm.get('password')?.errors?.password">Password
            must be at least 8 characters</mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- 5. OS -->
    <div class="section os-type-group" *ngIf="!isEdit">
      <label class="section-label" id="create-user-os-label">Employee’s operating system</label>
      <p class="os-helper">We’ll use this to provide the correct installer.</p>
      <mat-radio-group formControlName="operating_system" class="os-radio-group" aria-labelledby="create-user-os-label"
        (change)="onOperatingSystemChange($event.value)">
        <div class="os-options">
          <span class="os-option">
            <mat-radio-button class="os-tile" value="windows" (click)="onOperatingSystemChange('windows')">
              <mat-icon class="os-tile-icon" aria-hidden="true">desktop_windows</mat-icon>
              <span class="os-tile-name">Windows 10 &amp; 11</span>
            </mat-radio-button>
          </span>
          <span class="os-option">
            <mat-radio-button class="os-tile" value="windows_7_8" (click)="onOperatingSystemChange('windows_7_8')">
              <mat-icon class="os-tile-icon" aria-hidden="true">computer</mat-icon>
              <span class="os-tile-name">Windows 7 &amp; 8</span>
            </mat-radio-button>
          </span>
          <span class="os-option">
            <mat-radio-button class="os-tile" value="mac" (click)="onOperatingSystemChange('mac')">
              <mat-icon class="os-tile-icon" aria-hidden="true">laptop_mac</mat-icon>
              <span class="os-tile-name">macOS</span>
            </mat-radio-button>
          </span>
          <span class="os-option">
            <mat-radio-button class="os-tile" value="linux" (click)="onOperatingSystemChange('linux')">
              <mat-icon class="os-tile-icon" aria-hidden="true">code</mat-icon>
              <span class="os-tile-name">Linux</span>
            </mat-radio-button>
          </span>
        </div>
      </mat-radio-group>
    </div>

    <!-- The random-email toggle used to live here. Hidden mode sets a placeholder email automatically;
         Manual/Automatic employees sign in with a real email. -->

  </div>
  <!-- Footer -->
  <div class="modal-footer">
    <p class="footer-hint" *ngIf="createDisabledReason" role="status">{{ createDisabledReason }}</p>
    <button mat-stroked-button type="button" class="footer-btn cancel-btn" (click)="modalClose()">Cancel</button>
    <button mat-flat-button color="primary" type="button" class="footer-btn create-btn"
      [disabled]="!createUserForm.valid || isDisable" (click)="isEdit ? EditNewUser() : createNewUser()">
      {{ isEdit ? 'Save' : (isActivationHandoff ? 'Add employee' : 'Add employee') }}
    </button>
  </div>
</form>
<app-loader *ngIf="loading"></app-loader>
